import { Form, Formik } from 'formik';
import React, { useEffect } from 'react';
import OtpInput from 'react-otp-input';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from 'src/components/button';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';

interface IProps {}

const Otp: React.FC<IProps> = ({}) => {
  const [errorMsg, setErrorMsg] = React.useState('');
  const [code, setCode] = React.useState('');
  const handleChange = (code: string, submitForm: () => void) => {
    setCode(code);
    if (code.length === 5) {
      submitForm(); // Submit the form when code length is 4
    }
  };

  const handleKeyPress = (
    event: React.KeyboardEvent<HTMLInputElement>,
    submitForm: () => void
  ) => {
    if (event.key === 'Enter' && code.length === 5) {
      submitForm(); // Submit the form when code length is 4
    }
  };

  const location = useLocation();

  const navigate = useNavigate();
  const forgetPasswordPayload = {
    email: location?.state?.email,
    otp: code.toString(),
  };

  const payload = {
    ...location.state,
    otp: code.toString(),
  };
  const handleVerifyOtp = async () => {
    try {
      let data;
      if (location.state.forgetPassword) {
        ({ data } = await Service.post(
          '/employees/verifyforgototp',
          forgetPasswordPayload
        ));
        navigate('/reset-password', {
          state: forgetPasswordPayload,
        });
      } else {
        ({ data } = await Service.post('/auth/business/verifyOTP', payload));
        navigate('/login');
        // navigate('/pin-code', {
        //   state: data && data,
        // });
      }
      toastAlert(
        'success',
        data?.success ? 'Your Otp has been Verified.' : 'Something went Wrong'
      );
    } catch (err: any) {
      setErrorMsg(err?.response?.data?.message);
    }
  };

  const handleResendOtp = async () => {
    try {
      let data;
      if (location.state.forgetPassword) {
        ({ data } = await Service.post(
          '/employees/forgotPasswordOtp',
          location.state
        ));
      } else {
        ({ data } = await Service.post(
          '/auth/business/register',
          location.state
        ));
      }
      toastAlert('success', data?.message ?? 'Something went wrong.');
    } catch (err: any) {
      setErrorMsg(err?.response?.data?.message);
    }
  };

  return (
    <>
      <div></div>
      <div className="my-6 ">
        <h1 className="text-4xl font-semibold my-1">Otp Verification</h1>
        <h6 className="text-light-grey text-sm mt-2">
          Enter the code sent to
          <span className="font-semibold"> {location?.state?.email} </span>
        </h6>
        <Formik
          initialValues={{ code: '' }}
          onSubmit={handleVerifyOtp}
          validateOnMount
        >
          {({ isSubmitting, isValid, submitForm }) => (
            <Form className="flex flex-col items-stretch mt-6 gap-6 justify-">
              {errorMsg && (
                <p className="text-warning text-sm font-semibold mt-5">
                  {errorMsg}
                </p>
              )}
              <OtpInput
                value={code}
                onChange={(newCode: string) =>
                  handleChange(newCode, submitForm)
                }
                // onKeyDown={(event: any) => handleKeyPress(event, submitForm)}
                numInputs={5}
                separator={<span style={{ width: '20px' }}></span>}
                isInputNum={true}
                shouldAutoFocus={true}
                className="mt-5"
                inputStyle={{
                  border: '1px solid #CACFE3',
                  borderRadius: '8px',
                  width: '64px',
                  height: '64px',
                  fontSize: '15px',
                  color: '#000',
                  fontWeight: '400',
                }}
                focusStyle={{
                  border: '1px solid #4062FF',
                  outline: 'none',
                }}
              />
              {/* </div> */}

              <Button
                text="Verify"
                type="submit"
                variant="primary"
                isSubmitting={isSubmitting}
                isValid={isValid}
                className="w-full mt-5"
                disabled={code.length < 5}
              />
            </Form>
          )}
        </Formik>
      </div>
      <p className="mt-5 text-center">
        {`Didn’t get the code?`}

        <span
          className="text-primary font-semibold mx-2 cursor-pointer "
          onClick={handleResendOtp}
        >
          Resend code
        </span>
      </p>
    </>
  );
};

export default React.memo(Otp);
